import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	finishForm: {
		...THEME.common.scrollBar,
		maxHeight: '60vh',
		minHeight: 0,
		overflowY: 'auto',
	},
	card: {
		backgroundColor: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
	},
	title: {
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	detail: {
		color: THEME.colors.text.light,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
	},
	metaRow: {
		display: 'flex',
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.xs,
	},
	metaLabel: {
		color: THEME.colors.text.light,
	},
	metaValue: {
		color: THEME.colors.text.main,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	explanation: {
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
		marginTop: THEME.spacing.xs,
	},
	actionButton: {
		alignSelf: 'flex-start',
		marginTop: THEME.spacing.xs,
	},
	annotations: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	annotationLink: {
		alignSelf: 'flex-start',
	},
});
